export default "__VITE_ASSET__DQAGRy4Z__"